module.exports = __webpack_public_path__ + "img/motor.ed439355.png";